<template>
  <header class="border-b border-gray-100 bg-white" data-desktop-top-nav>
    <div class="flex h-14 items-center gap-4 px-4">
      <nuxt-link
        :to="localePath({ name: 'index' })"
        class="flex flex-none items-center gap-2"
        aria-label="首頁"
      >
        <img
          :src="logo"
          alt=""
          class="h-8 w-8 object-contain"
        />
        <span class="text-base font-bold text-gray-900">{{ appName }}</span>
      </nuxt-link>

      <nav class="flex h-full items-stretch gap-1" aria-label="主要導覽">
        <nuxt-link
          v-for="nav in navs"
          :key="nav.name"
          :to="localePath({ name: nav.name })"
          class="flex items-center gap-1.5 px-3 text-sm hover:text-primary"
          :class="isActive(nav.names) ? 'font-bold text-primary' : 'text-gray-500'"
          :aria-current="isActive(nav.names) ? 'page' : undefined"
        >
          <component :is="nav.icon" class="h-4 w-4 flex-none" />
          {{ nav.text }}
        </nuxt-link>
      </nav>

      <div class="ml-auto flex items-center gap-2">
        <select
          v-if="locales.length && !isAlipayHK"
          class="field w-auto flex-none border-none bg-transparent py-1 pr-8 text-sm text-gray-600"
          aria-label="選擇語言與地區"
          @change="changeLocal"
        >
          <option
            v-for="item in locales"
            :key="item.code"
            :value="item.code"
            :selected="$i18n.locale == item.code"
            v-text="item.name"
          />
        </select>

        <button
          type="button"
          class="relative flex h-11 flex-none items-center justify-center gap-2 whitespace-nowrap rounded-lg px-3 text-sm text-gray-600 hover:bg-gray-50"
          aria-label="購物車"
          @click="$root.$emit('toggle-cart')"
        >
          <ShoppingBagIcon class="h-5 w-5" />
          <span>購物車</span>
          <span
            v-if="count"
            class="absolute -right-0.5 -top-0.5 flex h-4 min-w-[16px] items-center justify-center rounded-full bg-primary px-1 text-[10px] font-bold text-white"
          >
            {{ count }}
          </span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import { startsWith } from 'lodash';
import { ShoppingBagIcon, HomeIcon, UserIcon, ClipboardIcon } from '@vue-hero-icons/outline';
import { mapGetters } from 'vuex';
import { PRIMARY_NAV } from '@/utils/desktopChrome';

export default {
  components: { ShoppingBagIcon, HomeIcon, UserIcon, ClipboardIcon },

  data() {
    return {
      navs: PRIMARY_NAV,
    };
  },

  computed: {
    ...mapGetters({
      locales: 'app/locales',
      count: 'cart/count',
      imgs: 'app/imgs',
      info: 'app/info',
    }),
    logo() {
      return this.imgs?.logo || '/logo.png';
    },
    appName() {
      return this.info?.name || '達人商城';
    },
  },

  methods: {
    isActive(arr) {
      const name = this.$route.name;
      for (let index = 0; index < arr.length; index++) {
        if (startsWith(name, arr[index])) return true;
      }
      return false;
    },
    async changeLocal(el) {
      const fromLocale = this.$i18n.locale;
      const locale = el.target.value;
      if (this.$track && fromLocale !== locale) {
        this.$track.event('region_change', {
          from_region: fromLocale,
          to_region: locale,
        });
      }
      this.$i18n.setLocale(locale);
      this.$cookies.set('loc', locale);
      window.location.href = this.localePath(this.$route.path);
    },
  },
};
</script>
